import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import './GameDev.css';
import {Helmet} from 'react-helmet'

import BIRDS from 'vanta/dist/vanta.birds.min'

import * as THREE from 'three';
import { useHistory } from "react-router-dom";
import FooterNew from '../../components/layouts/FooterNew';
//import { Scene } from 'three';

//import zIndex from '@material-ui/core/styles/zIndex';

export default class GameDev extends Component {
  
    constructor() {
        super()
        this.vantaRef = React.createRef()
        this.comingSoon=this.comingSoon.bind(this)
      }
      comingSoon=(e)=>{
          alert("Shoot En Stunt Coming Soon!");
      }
      componentDidMount() {
        this.vantaEffect = BIRDS({
          el: this.vantaRef.current,
          THREE: THREE,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.00,
          minWidth: 200.00,
          scale: 1.00,
          scaleMobile: 1.00,
          backgroundColor: 0xe5e5e5
       
        })}
        componentWillUnmount() {
            if (this.vantaEffect) 
              this.vantaEffect.destroy()
            }

            routeChange=()=> {
                let path = '/GameDev';
                let history = useHistory();
                history.push(path);
              }
            
            
    render() {
    
        return (
            <div className="rootHomeG"  ref={this.vantaRef}>
                <Helmet>
                    <title>Game Development</title>
                    <meta name="description"
      content="Welcome to Westvindh Games. Creator of Pilli Go and more upcoming futuristic games. Explore the whole new experience of mobile gaming. Join us now."/>
                </Helmet>
                
                <div className="linkCardsG">
                <Grid container spacing={0}>     
                     <Grid item xs={12} sm={6}>
                        <div onClick={event =>  window.location.href='/http://westvindh.com'} className="gridElementG">
                            {/* <a style={{textDecoration:"none"}} href='/Appdev'> */}
                        <div className="cardImgG">
                            <img className="PilliImgG"  src={require('../images/pilli.png')} alt="pilli"/>
                           </div>
                            <div className='cardTextG'style={{paddingLeft:"20%"}}>
                                <h1 className="cdlgtxtG">PILLI GO</h1>
                                {/* <h1 className="cdmdtxtG">DEVELOPMENT</h1> */}
                                {/* <h1 className="cdsmtxtG">...</h1>

                                <h1 className="cdsmtxtG">BRING MORE CUSTOMERS ROCKET YOUR BUSINESS</h1> */}
                            </div>
                            
                        </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                        <div onClick={this.comingSoon.bind(this)}  className="gridElementG">
                        <div className="cardImgG">
                            <img className="ShootImgG" src={require('../images/coming-soon-png-images-5.png')} alt="gamedev"/>
                          </div>
                            <div className='cardTextG Right'  >
                                <h1 className="cdlgtxtG">SHOOT</h1>
                                <h1 className="cdlgtxtG">EN SHUNT</h1>

                               
                                {/* <h1 className="cdsmtxtG" >...</h1>

                               {/* <button className="gamebt"> <a href="http://westvindh.com"className="cdsmtxtLinks">PILLI GO</a></button> <button className="gamebt" style={{marginBottom:"4%"}}> <a onClick={this.comingSoon.bind(this)} className="cdsmtxtLinks"> SHOOT EN STUNT</a></button> 
                               <h1 className="cdsmtxtG">CHECK OUT OUR GAMES</h1> */}
                            </div>
                        </div>
                        </Grid>
                        {/* <Grid item xs={12} sm={6}>
                        <div onClick={event =>  window.location.href='/ArtServices-En'} className="gridElement">
                            <div className="cardImg">
                            <img className="animImg"src={require('../images/2.png')} alt="animation"/>
                            </div>
                            <div className='cardText' style={{paddingLeft:"22%"}}>
                                <h1 style={{color:'#FF7719'}}className="cdlgtxt lgchartxt">CHARACTER</h1>
                                <h1 style={{color:'#FF7719'}}className="cdmdtxt">ARTIST</h1>
                                <h1 className="cdsmtxt">...</h1>

                                <h1 className="cdsmtxt">ASSET FOR YOUR GAMES</h1>
                            </div>
                        </div> 
                        </Grid>*/}
                        {/* <Grid item xs={12} sm={6}>
                        <div className="gridElement">
                        <div className="cardImg">
                            <img className="portImg" src={require('../images/3-min.png')} alt="portfolio"/>
                           </div>
                            <div className='cardText' style={{paddingLeft:"20%"}}>
                                <h1 className="cdlgtxt">OUR</h1>
                                <h1 className="cdmdtxt">PORTFOLIO</h1>
                                <h1 className="cdsmtxt">...</h1>

                                <h1 className="cdsmtxt">COMING SOON</h1>
                                <h1 className="cdsmtxt">JAN 2021</h1>

                            </div>
                        </div>
                        </Grid> */}
                </Grid>
                </div>
                <FooterNew />
            </div>
            
        )
    }
}
